import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { nextPageRoute } from "../utils/modules";
import ImageLoader from "./ImageLoader";

const HorizontalLeftButton = ({
  navigateTo,
  image,
  label,
  className,
  imgClass,
  imagesToPreload,
  placeHolderImage,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleNavigate = () => {
    nextPageRoute(navigate, navigateTo, dispatch, imagesToPreload);
  };

  return (
    <button
      tabIndex="0"
      onClick={handleNavigate}
      className="my-2 btn container-fluid rounded-2 d-flex align-items-center px-3  object-fit-contain link-underline link-underline-opacity-0 button-highlight"
      style={{
        backgroundColor: "#F2F2F2",
      }}
    >
      {image && (
        <div
          className="d-flex justify-content-center  align-content-center "
          style={{ height: "38px", width: "38px" }}
        >
          <ImageLoader
            src={image}
            placeHolderImage={placeHolderImage}
            alt="emoji"
            className={imgClass}
            style={{
              maxHeight: "40px",
              maxWidth: "60px",
              objectFit: "contain",
            }}
          />
        </div>
      )}
      <p
        className={`m-0 fw-bold text-start ${className}`}
        style={{
          paddingTop: "20px",
          paddingBottom: "20px",
          paddingLeft: "10px",
        }}
      >
        {label}
      </p>
    </button>
  );
};

export default HorizontalLeftButton;
